// extracted by mini-css-extract-plugin
export var avatarContainer = "_p-0";
export var avatarTypingWave = "_p-i";
export var gray = "_p-f";
export var green = "_p-c";
export var icon = "_p-9";
export var image = "_p-1";
export var lg = "_p-6";
export var md = "_p-5";
export var presenceDot = "_p-b";
export var red = "_p-d";
export var sm = "_p-4";
export var status = "_p-a";
export var typingDot = "_p-h";
export var typingPill = "_p-g";
export var xl = "_p-7";
export var xs = "_p-3";
export var xxl = "_p-8";
export var xxs = "_p-2";
export var yellow = "_p-e";